
























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { QueryUserMemberChangeRecordById} from '@/api'

@Component({
  components: {
  },
})
export default class CreateNewUserDialog extends Vue {

  @Emit('close')
  private close() {
    this.data = {}
    this.show = false
  }
  private data: any = {
    mobilePhone: undefined,
    nickname: undefined,
    inviteCode: undefined,
    password: undefined,
  }
  private show = false
  private isEdit = false
  private memberList: Array<any> = []



  public open(id:any) {
    this.loadData(id)
    this.show = true
  }

  private loadData(id:any){
    QueryUserMemberChangeRecordById({id:id}).then((res : any)=>{
      this.data = res
    })
  }


}
